import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';

@Directive({
  selector: '[lazyLoad]'
})
export class LazyLoadDirective {
  @Output() public lazyLoad = new EventEmitter();

  private observer: IntersectionObserver;

  constructor(private el: ElementRef) {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.observer.disconnect();
          this.lazyLoad.emit();
        }
      });
    });

    this.observer.observe(this.el.nativeElement);
  }
}
